export default __webpack_public_path__ + "static/media/logo.bba97d35.svg";